import { render } from "./ModuleMgmt.vue?vue&type=template&id=2e5cba14&scoped=true"
import script from "./ModuleMgmt.vue?vue&type=script&lang=js"
export * from "./ModuleMgmt.vue?vue&type=script&lang=js"

import "./ModuleMgmt.vue?vue&type=style&index=0&id=2e5cba14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5cba14"]])

export default __exports__